<template>
	<div id="commonContain">
		<el-tooltip id="myAutocomplete" effect="light" :style="{width: myWidth}" :content="myCommonShowName" placement="top">
			<el-autocomplete :trigger-on-focus="false" :fetch-suggestions="searchListByInput" :readonly="ShowNameReadonly" @select="handleSelect" v-model="myCommonShowName" :placeholder="myCommomShowPlaceholder" class="input-with-select">
				<el-button type="danger" slot="append" icon="el-icon-delete" @click="deleteBtnClick"></el-button>
				<el-button style="margin-left: 1px;" type="primary" slot="append" icon="el-icon-plus" @click="addBtnClick"></el-button>
			</el-autocomplete>
		</el-tooltip>
		<el-dialog id="commonDialog" :visible.sync="dialogVisible" :width="myCommonDialogWidth" @opened="openedDialog" :before-close="handleClose" :show-close="true" center append-to-body>
			<span slot="title" class="dialog-title">
				<span style="padding-bottom: 0px;padding-left: 20px; float: left;">
				<img src="../../assets/img/BlueCoral.png" height="27px"/>
        		</span> {{myCommonDialogTitle}}
			</span>
			<el-row style="border-top:1px solid #B5B5B5;">
				<el-col :span="leftCol" style="text-align: center;">
					<el-tabs v-model="tabsName" type="card" :stretch="stretch">
						<el-tab-pane name="firstTree">
							<span slot="label" style="font-size: 18px;"><i class="el-icon-date"></i> 所有</span>
							<el-row>
								<el-col :span="24" class="commonTreeSearch">
									<el-input style="margin-left: 5px;" placeholder="快速搜索" v-model="filterText">
									</el-input>
								</el-col>
							</el-row>
							<div style="height:350px;margin-top: 10px;width: 490px;" v-loading="loading">
								<el-scrollbar style="height: 100%;width: 100%;">
									<el-tree class="filter-tree" :data="myCommonTreeData" :props="defaultProps" @node-click="handleNodeClick" :filter-node-method="searchData" accordion :check-strictly="myTreeStrictly" :show-checkbox="showCheckBox" :node-key="myTreeId" @check-change="nodeCheckClick" highlight-current ref="myCommonTree">
										<span class="custom-tree-node" v-on:dblclick="treeNodeDblClick(data)" slot-scope="{ node, data }">
        									<span style="padding-bottom: 0px;display: inline-block;width: 230px;text-align: left;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;">
        									<img v-for="(value,key) in myImageType" v-if="data[myType]==value.type" :key="key" :src="value.imgPath" height="20px"/>
        									{{ node.label}}
        									</span>
        									<span v-for="(value,key) in myFiledList" :key="key" style="display: inline-block;width:200px;text-align: left;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;">
        										{{data[value]}}
        									</span>
										</span>
									</el-tree>
								</el-scrollbar>
							</div>
						</el-tab-pane>
						<el-tab-pane name="secondTree">
							<span slot="label" style="font-size: 18px;"><i class="el-icon-date"></i> 常用</span>
							<el-row>
								<el-col :span="24" class="commonTreeSearch">
									<el-input style="margin-left: 5px;" placeholder="快速搜索" v-model="filterTextForOften">
									</el-input>
								</el-col>
							</el-row>
							<div style="height:350px;margin-top: 10px;width: 490px;" v-loading="loading">
								<el-scrollbar style="height: 100%;width: 100%;">
									<el-tree class="filter-tree" :data="myCommonOftenUseTreeData" :props="defaultProps" @node-click="handleNodeClick" :filter-node-method="searchData" accordion :check-strictly="myTreeStrictly" :show-checkbox="showCheckBox" :node-key="myTreeId" @check-change="oftenUseNodeCheckClick" highlight-current ref="myCommonOftenUseTree">
										<span class="custom-tree-node" v-on:dblclick="treeNodeDblClick(data)" slot-scope="{ node, data }">
        									<span style="padding-bottom: 0px;display: inline-block;width: 230px;text-align: left;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;">
        									<img v-for="(value,key) in myImageType" v-if="data[myType]==value.type" :key="key" :src="value.imgPath" height="20px"/>
        									{{ node.label}}
        									</span>
        									<span v-for="(value,key) in myFiledList" :key="key" style="display: inline-block;min-width:200px;text-align: left;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;">
        										{{data[value]}}
        									</span>
										</span>
									</el-tree>
								</el-scrollbar>
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-col>
				<el-col v-if="showRightCol==true" :span="rightCol" style="text-align: center;border-left:1px solid #B5B5B5;height: 460px;">
					<div style="padding: 8px 0px 10px 0px;background-color: rgb(218, 240, 247)">
						<span style="font-size: 18px;">{{myCommonCheckedDescription}}</span>
					</div>
					<div style="margin:0px 15px;">
						<el-table :data="myCommonTableData" height="400px" style="width: 100%" header-align="center">
							<el-table-column :label="myShowFieldName" width="115">
								<template slot-scope="scope">
									<div slot="reference" class="name-wrapper">
										<el-tag size="medium">{{ scope.row[myShowField]}}</el-tag>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="60">
								<template slot-scope="scope">
									<el-button type="danger" icon="el-icon-close" @click="deleteTableBtnClick(scope.$index, scope.row)" circle></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-col>
			</el-row>
			<div style="text-align: right;">
				<el-button @click="closeDialogBtnClick">清空</el-button>
				<el-button type="primary" @click="sureBtnClick('')">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { listToTree } from '@/api/modules/basicData/commonData'
	export default {
		name: 'commonOftenSelectComponent',
		data() {
			return {
				//自定义
				myCommonShowName: '', //最终确认后输入框显示名
				myCommonShowPlaceholder: '', //输入框默认提示
				myCommonDialogTitle: '传入的Title',
				myCommonCheckedDescription: '',
				myCommonDialogWidth: '770px',
				myImageType: [],
				myFiledList: [],
				myCommonListData: [],
				myCommonTreeData: [],
				myCommonOftenUseListData: [],
				myCommonOftenUseTreeData: [],
				dataForIsRadio: {},
				myShowField: '',
				myShowFieldName: '',
				myType: '',
				myTreeId: '',
				//公共属性
				myCommonSelectedData: [],
				myCommonTableData: [],
				filterText: '',
				filterTextForOften: '',
				distinguishVal: false, //区别是否搜索后被动点击
				dialogVisible: false,
				ShowNameReadonly: false, //外部输入框只读
				stretch: true, //tab选择卡充满
				tabsName: 'secondTree', //默认展示
				defaultProps: {
					id: 'Id',
					children: 'children',
					label: ''
				},
				deleteArr: [],
				deptList: '',
				leftCol: 17,
				rightCol: 7,
				showRightCol: true,
				loading: false,
				myWidth: '',
				myTreeStrictly: false,
				showCheckBox: true
			};
		},
		props: {
			//设置项
			myOption: {
				type: Object,
				default: function() {
					return {
						commomShowPlaceholder: '', //输入框默认提示
						commonDialogTitle: '', //弹出窗标题
						commonCheckedDescription: '', //右侧table标题
						isRadio: true, //单双选
						setWidth: '',
						isStrictly: false,
						searchContainsSubsets: false
					}
				}
			},
			//数据项
			myData: {
				type: Object,
				default: function() {
					return {
						idArray: [],
						imageType: [],
						checkField: {
							Id: '', //区别上下级
							Pid: '',
							Key: '', //数据标识，相同key则为同一条数据（例如不同组织下同一人）
							Type: '', //类型区别字段如Type
							TypeValue: [], //有效的type值
							ValidField: [], //可搜索字段
							ShowField: '', //确认后显示字段
							ShowFieldName: '',
							FiledList:[]//附件字段
						}
					}
				}
			},
		},
		mounted() {
			console.log("mydata:", this.myData);
		},
		watch: {
			filterText(val) {
				this.debouncedSearch(val)
			},
			filterTextForOften(val) {
				this.debouncedSearchForOften(val)
			},
			'myCommonTableData': {
				handler(val, oldVal) {
					if(val.length > 0) {
						this.ShowNameReadonly = true
					} else {
						this.ShowNameReadonly = false
					}
				},
				deep: true //深度监听
			},
			'myData.idArray': {
				handler(val, oldVal) {
					var _this = this
					if(val.length > 0) {
						if(this.myCommonListData.length == 0) {
							this.$emit("setValue", '', function(list) { //调用取值方法
								_this.myCommonListData = list
								for(var i = 0; i < val.length; i++) {
									begin: for(var j = 0; j < _this.myCommonListData.length; j++) {
										if(val[i] == _this.myCommonListData[j][_this.myData.checkField.Key]) {
											if(_this.checkIsExit(_this.myCommonTableData, _this.myCommonListData[j]) != false) {
												_this.myCommonTableData.push(_this.myCommonListData[j])
											}
											break begin;
										}
									}
								}
								this.inputAssignment(_this.myCommonTableData)
								this.$emit("getValue", _this.myCommonTableData, function(str) { //传递值
									console.log('传递完成')
								});
							});
						} else {
							for(var i = 0; i < val.length; i++) {
								begin: for(var j = 0; j < _this.myCommonListData.length; j++) {
									if(val[i] == _this.myCommonListData[j][_this.myData.checkField.Key]) {
										if(_this.checkIsExit(_this.myCommonTableData, _this.myCommonListData[j]) != false) {
											_this.myCommonTableData.push(_this.myCommonListData[j])
										}
										break begin;
									}
								}
							}
							this.inputAssignment(_this.myCommonTableData)
							this.$emit("getValue", _this.myCommonTableData, function(str) { //传递值
								console.log('传递完成')
							});
						}
					}
				},
				deep: true //深度监听
			},
		},
		created() {
			this.setOption() //设置配置项
			this.setData() //设置数据及编辑项
			//构建搜索，限制频率
			var _ = require('lodash');
			this.debouncedSearch = _.debounce(this.searchData, 1000)
			this.debouncedSearchForOften = _.debounce(this.searchDataForOften, 1000)
		},
		methods: {
			//设置配置项
			setOption() {
				if(this.myOption.isRadio == true) {
					this.showCheckBox = false //不显示多选框
					this.leftCol = 24 //重新布局，不显示右侧表格
					this.rightCol = 0
					this.showRightCol = false
					this.myCommonDialogWidth = "560px" //重新定义宽度
				}
				//自定义弹出框头部信息
				if(this.myOption.commonDialogTitle != '') {
					this.myCommonDialogTitle = this.myOption.commonDialogTitle
				} else {
					this.myCommonDialogTitle = '默认标题'
				}
				//表格描述信息
				if(this.myOption.commonCheckedDescription != '') {
					this.myCommonCheckedDescription = this.myOption.commonCheckedDescription
				} else {
					this.myCommonCheckedDescription = '默认描述'
				}
				//自定义弹出框宽度
				//				if(this.myOption.commonDialogWidth != '') {
				//					this.myCommonDialogWidth = this.myOption.commonDialogWidth
				//				} else {
				//					this.myCommonDialogWidth = '770px'
				//				}
				//自定义外部输入框提示信息
				if(this.myOption.commomShowPlaceholder != '') {
					this.myCommomShowPlaceholder = this.myOption.commomShowPlaceholder
				} else {
					this.myCommomShowPlaceholder = '默认提示'
				}
				//自定义宽度
				if(this.myOption.setWidth != '') {
					this.myWidth = this.myOption.setWidth
				} else {
					this.myWidth = '250px'
				}
				if(this.myOption.isStrictly == true) {
					this.myTreeStrictly = true
				} else {
					this.myTreeStrictly = false
				}
				this.myShowField = this.myData.checkField.ShowField
				this.myShowFieldName = this.myData.checkField.ShowFieldName
				this.myFiledList=this.myData.checkField.FiledList
				this.myType = this.myData.checkField.Type
				this.myTreeId = this.myData.checkField.Id
				this.defaultProps.label = this.myData.checkField.ShowField
			},
			//设置数据源
			setData() {
				var _this = this
				//获取全部数据list
				if(this.myCommonListData.length == 0) {
					this.$emit("setValue", '', function(list) { //调用取值方法
						_this.myCommonListData = list;
						_this.myCommonTreeData = listToTree(_this.myData.checkField.Id, _this.myData.checkField.Pid, _this.myCommonListData)
					});
				} else {
					_this.myCommonTreeData = listToTree(_this.myData.checkField.Id, _this.myData.checkField.Pid, _this.myCommonListData)
				}
				//获取常用数据list
				if(this.myCommonOftenUseListData.length == 0) {
					this.$emit("setOftenUseValue", '', function(list) { //调用取值方法
						_this.myCommonOftenUseListData = list;
						_this.myCommonOftenUseTreeData = listToTree(_this.myData.checkField.Id, _this.myData.checkField.Pid, _this.myCommonOftenUseListData)
					});
				} else {
					_this.myCommonOftenUseTreeData = listToTree(_this.myData.checkField.Id, _this.myData.checkField.Pid, _this.myCommonOftenUseListData)
				}
				//获取编辑项ID，清空之后绑定
				if(this.myData.idArray != '') {
					this.myIdArray = this.myData.idArray
				} else {
					this.myIdArray = []
				}
				//获取图片对应参数
				this.myData.imageType.forEach((c) => {
					this.myImageType.push(c)
				})
			},
			//---绑定点击事件Event---
			//点击外部添加按钮
			addBtnClick() {
				//弹出
				this.dialogVisible = true
			},
			//打开弹出框完成后回调，已有数据复制
			openedDialog() {
				var _this = this
				//弹出前判断当前是否存在值
				this.myCommonTableData.forEach((c) => {
					_this.checkAllTree(c[_this.myData.checkField.Key], '', true) //table赋值
				})
			},
			//点击外部清空按钮
			deleteBtnClick() {
				this.ShowNameReadonly = false
				this.myCommonShowName = ''
				this.myCommonTableData = []
				this.dataForIsRadio = {}
				if(this.$refs.myCommonTree != undefined && this.$refs.myCommonTree != 'undefined') {
					this.$refs.myCommonTree.setCheckedKeys([]);
				}
				if(this.$refs.myCommonOftenUseTree != undefined && this.$refs.myCommonOftenUseTree != 'undefined') {
					this.$refs.myCommonOftenUseTree.setCheckedKeys([]);
				}
				this.$emit("getValue", this.myCommonTableData, function(str) { //传递值，无论是否验证
					console.log('清理完成')
				});
			},
			//点击所有数据Tree多选框(存在选中与取消，主动点击与被动点击,初始折叠无法获取数据处理)
			nodeCheckClick(item, node, self) {
				if(this.myOption.isRadio != true) {
					if(node == true) { //点击未选中复选框
						if(this.myData.checkField.TypeValue.indexOf(item[this.myData.checkField.Type]) != -1) { //搜索完ID变化，通过IdType判断是否同一人
							if(this.verifyData(item) == true) { //通过验证
								if(this.checkIsExit(this.myCommonTableData, item) != false) { //不包含该元素
									this.myCommonTableData.push(item)
								}
								//找出不同组织下相同节点，并勾选
								this.checkAllTree(item[this.myData.checkField.Key], item[this.myData.checkField.Id], true)
							} else {
								this.$refs.myCommonTree.setChecked(item[this.myData.checkField.Id], false)
							}
						} else {
							//初始折叠无法获取数据处理
							var temporaryTreeArr = this.$refs.myCommonTree.getCheckedNodes()
							temporaryTreeArr.forEach((c) => {
								//判断当前数据是否在右侧table中			
								if(this.myData.checkField.TypeValue.indexOf(c[this.myData.checkField.Type]) != -1) { //不包含该元素
									if(this.verifyData(c) == true) {
										if(this.checkIsExit(this.myCommonTableData, c) != false) {
											this.myCommonTableData.push(c)
										}
										this.checkAllTree(c[this.myData.checkField.Key], c[this.myData.checkField.Id], true)
									} else {
										this.$refs.myCommonTree.setChecked(c[this.myData.checkField.Id], false)
									}
								}
							})
						}
					} else { //已选中
						if(this.myData.checkField.TypeValue.indexOf(item[this.myData.checkField.Type]) != -1) { //点击子节点
							if(this.distinguishVal != true) {
								this.updateTable(item[this.myData.checkField.Id])
								this.checkAllTree(item[this.myData.checkField.Key], item[this.myData.checkField.Id], false)
							}
						} else {
							if(self == false && this.myOption.isStrictly == false) { //搜索完之后，取消选中所有都取消
								this.searchNodeById(item[this.myData.checkField.Id], this.myCommonTreeData)
								this.deleteArr.forEach((c) => {
									this.updateTable(c[this.myData.checkField.Id])
									this.checkAllTree(c[this.myData.checkField.Key], c[this.myData.checkField.Id], false)
								})
								this.deleteArr = []
							}
						}
					}
				}
			},
			//点击所有数据Tree多选框(存在选中与取消，主动点击与被动点击,初始折叠无法获取数据处理)
			oftenUseNodeCheckClick(item, node, self) {
				if(this.myOption.isRadio != true) {
					if(node == true) { //点击未选中复选框
						if(this.myData.checkField.TypeValue.indexOf(item[this.myData.checkField.Type]) != -1) { //搜索完ID变化，通过IdType判断是否同一人
							if(this.verifyData(item) == true) { //通过验证
								if(this.checkIsExit(this.myCommonTableData, item) != false) { //不包含该元素
									this.myCommonTableData.push(item)
								}
								//找出不同节点下相同节点，并勾选
								this.checkAllTree(item[this.myData.checkField.Key], item[this.myData.checkField.Id], true)
							} else {
								this.$refs.myCommonOftenUseTree.setChecked(item[this.myData.checkField.Id], false)
							}
						} else {
							//初始折叠无法获取数据处理
							var temporaryTreeArr = this.$refs.myCommonOftenUseTree.getCheckedNodes()
							temporaryTreeArr.forEach((c) => {
								//判断当前数据是否在右侧table中			
								if(this.myData.checkField.TypeValue.indexOf(c[this.myData.checkField.Type]) != -1) { //不包含该元素
									if(this.verifyData(c) == true) {
										if(this.checkIsExit(this.myCommonTableData, c) != false) {
											this.myCommonTableData.push(c)
										}
										this.checkAllTree(c[this.myData.checkField.Key], c[this.myData.checkField.Id], true)
									} else {
										this.$refs.myCommonOftenUseTree.setChecked(c[this.myData.checkField.Id], false)
									}
								}
							})
						}
					} else { //已选中
						if(this.myData.checkField.TypeValue.indexOf(item[this.myData.checkField.Type]) != -1) { //点击子节点
							if(this.distinguishVal != true) {
								this.updateTable(item[this.myData.checkField.Id])
								this.checkAllTree(item[this.myData.checkField.Key], item[this.myData.checkField.Id], false)
							}
						} else {
							if(self == false && this.myOption.isStrictly == false) { //搜索完之后，取消选中所有都取消
								this.searchNodeById(item[this.myData.checkField.Id], this.myCommonOftenUseTreeData)
								this.deleteArr.forEach((c) => {
									this.updateTable(c[this.myData.checkField.Id])
									this.checkAllTree(c[this.myData.checkField.Key], c[this.myData.checkField.Id], false)
								})
								this.deleteArr = []
							}
						}
					}
				}
			},
			//勾选时调用验证方法
			verifyData(data) {
				var _this = this
				var result = true
				this.$emit("verifyMethod", data, function(verifyResult) { //调用验证方法
					if(verifyResult.status == true) {
						result = true
					} else {
						_this.$message.error(verifyResult.message);
						result = false
					}
				});
				return result
			},
			checkIsExit(arr, obj) {
				var filter = true
				arr.forEach((c) => {
					if(c[this.myData.checkField.Key] == obj[this.myData.checkField.Key]) {
						filter = false
					}
				})
				return filter
			},
			//通过相同数据ID(可能相同)找出唯一标识Key
			checkAllTree(code, id, trueOrFalse) {
				//所有数据树完成勾选
				for(var i = 0; i < this.myCommonListData.length; i++) {
					if(this.myCommonListData[i][this.myData.checkField.Key] == code &&
						this.myCommonListData[i][this.myData.checkField.Id] != id) {
						this.$refs.myCommonTree.setChecked(this.myCommonListData[i][this.myData.checkField.Id], trueOrFalse)
					}
				}
				//常用人员树完成勾选
				for(var i = 0; i < this.myCommonOftenUseListData.length; i++) {
					if(this.myCommonOftenUseListData[i][this.myData.checkField.Key] == code &&
						this.myCommonOftenUseListData[i][this.myData.checkField.Id] != id) {
						this.$refs.myCommonOftenUseTree.setChecked(this.myCommonOftenUseListData[i][this.myData.checkField.Id], trueOrFalse)
					}
				}
			},
			//取消勾选后更新table
			updateTable(code) {
				for(var i = 0; i < this.myCommonTableData.length; i++) {
					if(this.myCommonTableData[i][this.myData.checkField.Id] == code) {
						this.myCommonTableData.splice(i, 1)
					}
				}
			},
			searchNodeById(Id, treeData) {
				for(var i = 0; i < treeData.length; i++) {
					if(treeData[i][this.myData.checkField.Id] == Id) {
						//找到后遍历孩子
						this.searchTreeChilren(treeData[i])
						break;
					} else {
						if(treeData[i].hasOwnProperty('children')) {
							this.searchNodeById(Id, treeData[i].children)
						}
					}
				}
			},
			searchTreeChilren(treeData) {
				if(treeData.hasOwnProperty('children')) {
					for(var i = 0; i < treeData.children.length; i++) {
						if(this.myData.checkField.TypeValue.indexOf(treeData.children[i][this.myData.checkField.Type]) != -1) {
							this.deleteArr.push(treeData.children[i])
						} else {
							this.searchTreeChilren(treeData.children)
						}
					}
				}
			},
			//双击Tree节点(单选时)
			treeNodeDblClick(data) {
				if(this.myOption.isRadio == true && this.myData.checkField.TypeValue.indexOf(data[this.myData.checkField.Type]) != -1) {
					this.sureBtnClick(data)
				}
			},
			handleNodeClick(data) {
				if(this.myData.checkField.TypeValue.indexOf(data[this.myData.checkField.Type]) != -1) {
					this.dataForIsRadio = data
				}
			},
			//点击弹出框确认按钮
			sureBtnClick(data) {
				if(this.myOption.isRadio == true) {
					if(data == '') { //点击按钮
						if(Object.keys(this.dataForIsRadio).length > 0) {
							this.myCommonTableData = []
							this.myCommonTableData.push(this.dataForIsRadio)
						} else {
							this.myCommonTableData = []
						}
					} else { //双击
						this.myCommonTableData = []
						this.myCommonTableData.push(data)
					}
				}
				this.inputAssignment(this.myCommonTableData)
				this.$emit("getValue", this.myCommonTableData, function(str) { //传递值
					console.log('传递完成')
				});
				this.filterText = ""
				this.dialogVisible = false
			},
			//赋值输入框
			inputAssignment(val) {
				this.myCommonShowName = ''
				val.forEach((c) => {
					this.myCommonShowName += c[this.myData.checkField.ShowField] + ','
				})
				this.myCommonShowName = this.myCommonShowName.substring(0, this.myCommonShowName.lastIndexOf(','));
			},
			//点击右侧Table删除按钮
			deleteTableBtnClick(index, row) {
				this.updateTable(row[this.myData.checkField.Id])
				var temporaryTreeArr_All = this.$refs.myCommonTree.getCheckedNodes()
				var temporaryTreeArr_Often = this.$refs.myCommonOftenUseTree.getCheckedNodes()
				var temporaryTreeArr = temporaryTreeArr_All.concat(temporaryTreeArr_Often)
				for(var i = 0; i < temporaryTreeArr.length; i++) {
					if(temporaryTreeArr[i][this.myData.checkField.Key] == row[this.myData.checkField.Key]) {
						//如果IdType一样视为同一人，取消选中
						this.$refs.myCommonTree.setChecked(temporaryTreeArr[i][this.myData.checkField.Id], false)
						/*
						 * todo
						 * 取消所有相同数据
						 */
						this.$refs.myCommonOftenUseTree.setChecked(temporaryTreeArr[i][this.myData.checkField.Id], false)
					}
				}
			},
			//点击弹出窗清空
			closeDialogBtnClick() {
				this.$confirm('此操作将清空当前数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.deleteBtnClick()
					this.$message({
						type: 'success',
						message: '清空成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消清空'
					});
				});
			},
			//执行搜索
			toSearch(val) {
				this.$refs.myCommonTree.filter(val); //myCommonOftenUseTree
			},
			//常用数据搜索
			searchDataForOften(keyWord) {
				this.distinguishVal = true //重绑树后不被动执行点击事件
				var _this = this
				this.loading = true
				var arr = []
				var tableData = []
				this.myCommonTableData.forEach((c) => {
					tableData.push(c)
				})
				if(keyWord != null && keyWord != '') {
					var keyWordInit = keyWord
					var keyWordUp = keyWord.toUpperCase()
					var _this = this
					this.myCommonOftenUseListData.forEach((c) => {
						now: for(var i = 0; i < _this.myData.checkField.ValidField.length; i++) {
							if(c[_this.myData.checkField.ValidField[i]] != null) {
								if(c[_this.myData.checkField.ValidField[i]].indexOf(keyWordInit) != -1 ||
									c[_this.myData.checkField.ValidField[i]].indexOf(keyWordUp) != -1) {
									arr.push(c) //只添加有效字段list
									break now;
								}
							}
						}
					})
					this.myCommonOftenUseTreeData = listToTree(this.myData.checkField.Id, this.myData.checkField.Pid, this.searchParentsNode(arr,this.myCommonOftenUseListData))
				} else {
					this.myCommonOftenUseListData.forEach((c) => {
						arr.push(c)
					})
					this.myCommonOftenUseTreeData = listToTree(this.myData.checkField.Id, this.myData.checkField.Pid, arr)
				}
				//少于100展开节点
				if(arr.length <= 100 && arr.length > 0) {
					this.$refs.myCommonOftenUseTree.store.defaultExpandAll = true
				} else {
					this.$refs.myCommonOftenUseTree.store.defaultExpandAll = false
				}
				setTimeout(function() {
					for(var j = 0; j < tableData.length; j++) {
						for(var i = 0; i < arr.length; i++) {
							if(arr[i][_this.myData.checkField.Key] == tableData[j][_this.myData.checkField.Key]) { //如果Key一样视为同一人，选中
								_this.$refs.myCommonOftenUseTree.setChecked(arr[i][_this.myData.checkField.Id], true)
							}
						}
					}
				}, 0);
				this.distinguishVal = false
				this.loading = false
			},
			//弹出框关键字搜索
			searchData(keyWord) {
				this.distinguishVal = true //重绑树后不被动执行点击事件
				var _this = this
				this.loading = true
				var arr = []
				var tableData = []
				this.myCommonTableData.forEach((c) => {
					tableData.push(c)
				})
				if(keyWord != null && keyWord != '') {
					var keyWordInit = keyWord
					var keyWordUp = keyWord.toUpperCase()
					var _this = this
					this.myCommonListData.forEach((c) => {
						now: for(var i = 0; i < _this.myData.checkField.ValidField.length; i++) {
							if(c[_this.myData.checkField.ValidField[i]] != null) {
								if(c[_this.myData.checkField.ValidField[i]].indexOf(keyWordInit) != -1 ||
									c[_this.myData.checkField.ValidField[i]].indexOf(keyWordUp) != -1) {
									arr.push(c) //只添加有效字段list
									break now;
									//									_this.myData.checkField.TypeValue.indexOf(c[_this.myData.checkField.Type]!= -1
								}
							}
						}
					})
					this.myCommonTreeData = listToTree(this.myData.checkField.Id, this.myData.checkField.Pid, this.searchParentsNode(arr,this.myCommonListData))
				} else {
					this.myCommonListData.forEach((c) => {
						arr.push(c)
					})
					this.myCommonTreeData = listToTree(this.myData.checkField.Id, this.myData.checkField.Pid, arr)
				}
				//少于100展开节点
				if(arr.length <= 100 && arr.length > 0) {
					this.$refs.myCommonTree.store.defaultExpandAll = true
				} else {
					this.$refs.myCommonTree.store.defaultExpandAll = false
				}
				setTimeout(function() {
					for(var j = 0; j < tableData.length; j++) {
						for(var i = 0; i < arr.length; i++) {
							if(arr[i][_this.myData.checkField.Key] == tableData[j][_this.myData.checkField.Key]) { //如果Key一样视为同一人，选中
								_this.$refs.myCommonTree.setChecked(arr[i][_this.myData.checkField.Id], true)
							}
						}
					}
				}, 0);
				this.distinguishVal = false
				this.loading = false
			},
			searchParentsNode(list,allListData) {
				const idMap = new Map();
				const pidMap = new Map();
				for(var i = 0; i < allListData.length; i++) {
					idMap.set(allListData[i][this.myData.checkField.Id], allListData[i]);
					pidMap.set(allListData[i][this.myData.checkField.Pid], "isFather");
				}
				const exitMap = new Map();
				var parentArr = []
				var allData = []
				var childArr = []
				var initList = []
				if(this.myOption.searchContainsSubsets == true) {
					for(var i = 0; i < list.length; i++) {
						exitMap.set(list[i][this.myData.checkField.Id], list[i]);
						initList.push(list[i])
						allData.push(list[i])
						if(pidMap.has(list[i][this.myData.checkField.Id])) { //它是父节点
							parentArr.push(list[i])
							childArr.push(list[i])
						}
					}
					while(childArr.length) {
						var childNode = childArr.shift()
						for(var i = 0; i < allListData.length; i++) {
							////如果childNode有孩子，添加，继续判断孩子是否还有孩子
							if(allListData[i][this.myData.checkField.Pid] == childNode[this.myData.checkField.Id] &&
								!exitMap.has(allListData[i][this.myData.checkField.Id])) {
								childArr.push(allListData[i])
								allData.push(allListData[i])
								exitMap.set(allListData[i][this.myData.checkField.Id], allListData[i]);
							}
						}
						//至此找完所有父节点孩子
					}
				} else {
					for(var i = 0; i < list.length; i++) {
						list[i].children = []
						exitMap.set(list[i][this.myData.checkField.Id], list[i]);
						initList.push(list[i])
					}
				}
				while(initList.length) {
					var parentNode = initList.shift()
					if(idMap.has(parentNode[this.myData.checkField.Pid]) && !exitMap.has(parentNode[this.myData.checkField.Pid])) {
						initList.push(idMap.get(parentNode[this.myData.checkField.Pid]))
						allData.push(idMap.get(parentNode[this.myData.checkField.Pid]))
						exitMap.set(parentNode[this.myData.checkField.Pid], parentNode);
					}
				}
				if(this.myOption.searchContainsSubsets == true) {
					return allData
				} else {
					return allData.concat(list)
				}

			},
			//外部快捷搜索
			searchListByInput(queryString, cb) {
				var _this = this
				var arr = []
				//queryString = queryString.toUpperCase()
				var keyWordInit = queryString
				var keyWordUp = queryString.toUpperCase()
				//检索有效字段
				this.myCommonListData.forEach((c) => {
					now: for(var i = 0; i < _this.myData.checkField.ValidField.length; i++) {
						if(c[_this.myData.checkField.ValidField[i]] != null) {
							if(c[_this.myData.checkField.ValidField[i]].indexOf(keyWordInit) != -1 ||
								c[_this.myData.checkField.ValidField[i]].indexOf(keyWordUp) != -1) {
								if(_this.myData.checkField.TypeValue.indexOf(c[_this.myData.checkField.Type]) != -1) {
									c.value = c[_this.myData.checkField.ShowField]
									arr.push(c) //只添加有效字段list
									break now;
								}
							}
						}
					}
				})
				cb(arr);
			},
			handleSelect(item) {
				if(this.verifyData(item) == true) {
					this.ShowNameReadonly = true
					this.myCommonTableData.push(item)
					this.$emit("getValue", this.myCommonTableData, function(str) { //传递值
						console.log('传递完成')
					});
				} else {
					this.myCommonShowName = ''
				}
			},
			handleClose(done) {
				this.dataForIsRadio = {}
				done();
			},
			filter(arr1, arr2) { /*arr1 传被检测对象，arr2传已存在的列表*/
				var arrRet = []
				for(var j = 0; j < arr1.length; j++) {
					var b = false
					for(var i = 0; i < arr2.length; i++) {
						if(arr1[j].Type == 1 || arr1[j].Type == 3) {
							b = true;
							break;
						}
						if(arr1[j].UserId == arr2[i].UserId) {
							b = true;
							break;
						}
					}
					if(!b && arr1[j].Type == 2) {
						arrRet.push(arr1[j]);
					}
				}
				return arrRet;
			}
		},
		computed: {}
	}
</script>

<style scoped>
	/*#myAutocomplete .el-button {
		padding: 11px 8px !important;
		margin: -10px 0px;
	}*/
	
	#commonContain .input-with-select {
		width: 100%;
	}
	
	#commonContain .el-tree-node__label {
		font-size: 16px;
	}
	
	#commonContain .custom-tree-node {
		box-sizing: border-box;
		flex: 1;
		display: flex;
		align-items: left;
		justify-content: space-between;
		font-size: 16px;
		height: 30px;
		line-height: 30px;
		padding-right: 8px;
	}
	
	#commonContain .custom-tree-node img {
		vertical-align: top;
		margin-top: 4px;
	}
	
	#commonContain .el-autocomplete-suggestion {
		width: 300px !important;
	}
	
	#commonDialog .el-dialog__body {
		text-align: initial;
		padding: 5px 25px 30px !important;
	}
	
	#myAutocomplete .el-input-group__append,
	.el-input-group__prepend {
		padding: 0 0px;
	}
	
	#myAutocomplete .el-input-group__append button.el-button {
		/* border-color: transparent;*/
		/*background-color:none;*/
		color: inherit;
		border-top: 0;
		border-bottom: 0;
	}
	
	.commonTreeSearch .el-input__inner {
		width: 500px
	}
	
	#commonContain .el-button {
		/*padding: 12px 12px !important;*/
		padding: 11px 8px !important;
		margin: -10px 0px;
	}
</style>